import React, { ReactNode } from 'react';
import { mapping } from './assets';
import { Link } from '@config';
import styled, { css } from 'styled-components';
import { hiDPI } from 'polished';
import { desktop } from '@styles';

export interface AppLinkProps {
  marketType: keyof typeof mapping;
  link: Link;
  children?: ReactNode;
}

export interface LinkProps {
  marketType: keyof typeof mapping;
}

const StyledAppLink = styled.a<LinkProps>`
  display: inline-block;
  width: 135px;
  height: 40px;
  background: url(${({ marketType }) => mapping[marketType]['1x']}) no-repeat;
  background-size: contain;
  
  ${hiDPI(2)} {
    background-image: url(${({ marketType }) => mapping[marketType]['2x']});
  }
  
  ${({ marketType }) => desktop(css`
    width: 270px;
    height: 80px;
    background-image: url(${mapping[marketType]['4x']});
  `)}
`;

const AppLink: React.FC<AppLinkProps> = ({ marketType, link, children }) => (
  <StyledAppLink
    href={link.href}
    target={link.target}
    marketType={marketType}
  >
    {children}
  </StyledAppLink>
);

export { AppLink };